module.exports = __webpack_public_path__ + "img/image10.bad9e5a2.png";